import sportsFirstScore from '../icons/sports-first-score.png';
import sportsSecondScore from '../icons/sports-second-score.png';
import sportsThirdScore from '../icons/sports-third-score.png';
import artFirstScore from '../icons/art-first-score.png';
import artSecondScore from '../icons/art-second-score.png';
import artThirdScore from '../icons/art-third-score.png';
import {TriviaTopic} from '../types';
import {StaticImageData} from 'next/image';

type Percentage = '80%-100%' | '20%-80%' | '0%-20%';

const scoreImgMap: Record<TriviaTopic, Record<Percentage, StaticImageData>> = {
  sports: {
    '0%-20%': sportsFirstScore,
    '20%-80%': sportsSecondScore,
    '80%-100%': sportsThirdScore,
  },
  art: {
    '0%-20%': artFirstScore,
    '20%-80%': artSecondScore,
    '80%-100%': artThirdScore,
  },
  misc: {
    '0%-20%': artFirstScore,
    '20%-80%': artSecondScore,
    '80%-100%': artThirdScore,
  },
};

export const getScorePercentage = (score: number, noOfQuestions: number): Percentage => {
  const percentage = (score / noOfQuestions) * 100;
  if (percentage >= 80) {
    return '80%-100%';
  } else if (percentage >= 20) {
    return '20%-80%';
  } else {
    return '0%-20%';
  }
};

export const getScoresPicture = (topic: TriviaTopic, score: number, noOfQuestions: number) => {
  const percentage = getScorePercentage(score, noOfQuestions);

  return scoreImgMap[topic][percentage].src;
};

export const getScoreStatus = (score: number, noOfQuestions: number) => {
  const percentage = getScorePercentage(score, noOfQuestions);
  if (percentage === '80%-100%') {
    return 'first';
  } else if (percentage === '20%-80%') {
    return 'second';
  } else {
    return 'third';
  }
};
